import { folderSchemas } from "@redotech/redo-views-common/folders";
import { viewWithIdSchemas } from "@redotech/redo-views-common/views";
import * as z from "zod";
import { null as zNull } from "zod";

export const saveConsolidationViewsAndFolders = {
  name: "saveConsolidationViewsAndFolders" as const,
  input: z.object({
    folders: z.array(folderSchemas.consolidations),
    views: z.array(viewWithIdSchemas.consolidations),
  }),
  output: zNull(),
};
